// extracted by mini-css-extract-plugin
module.exports = {"link":"main-navigation-module--link--5WN2i","current":"main-navigation-module--current--p7zi6"};